'use client'

import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { ReactSelectMenu } from '@repo/ui/ReactSelectMenu'
import { useLookupsStore } from '@repo/store/useLookupsStore'

export const ReviewTypeSelect = ({
  testData = null,
  value = null,
  onChange = (val) => {
    console.log(val)
  },
  sx,
  size = 'small',
  required
}) => {
  const { fetchReviewTypes, reviewTypes } = useLookupsStore()
  const [options, setOptions] = useState(testData || reviewTypes || [])

  useEffect(() => {
    if (testData) return
    setOptions(reviewTypes || [])
  }, [testData, reviewTypes])

  useEffect(() => {
    if (testData || reviewTypes?.length) return
    fetchReviewTypes()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testData, reviewTypes])

  return (
    <div data-testid="ReviewTypeSelect" style={{ width: sx?.width || '100%', maxWidth: sx?.maxWidth || '100%' }}>
      <ReactSelectMenu
        label="Review type"
        onChange={onChange}
        labelKey="description"
        valueKey="reviewTypeId"
        items={options}
        value={value}
        searchable
        idLabelKey="reviewTypeId"
        showIdInResults={false}
        name="reviewType"
        size={size}
        required={required}
      />
    </div>
  )
}

ReviewTypeSelect.propTypes = {
  testData: PropTypes.array,
  value: PropTypes.object,
  onChange: PropTypes.func,
  sx: PropTypes.object,
  size: PropTypes.string,
  required: PropTypes.bool
}
